<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <button
                        type="button"
                        id="export-table"
                        @click="onexport"
                        class="btn btn-success"
                        style="margin-bottom:5px"
                    >
                        Download Excel
                    </button>
                    <div class="scrollable-table">
                        <table
                            class="table table-centered table-striped table-bordered"
                            id="titledExcel"
                            style="overflow-x: auto"
                        >
                            <thead>
                                <tr>
                                    <th>SL</th>
                                    <th>EP ID</th>
                                    <th>Name</th>
                                    <th>Father`s/Husband Name</th>
                                    <th>Mother`s Name</th>
                                    <th>Award Book No.</th>
                                    <th>Mouza</th>
                                    <th>LA Case No.</th>
                                    <th>Plot No.</th>
                                    <th>Land Type</th>
                                    <th>Land Affected (Decimal)</th>
                                    <th>Cheque No.</th>
                                    <th>Cheque Received date</th>
                                    <th>CCL Land (TK.)</th>
                                    <th>CCL Structure (TK.)</th>
                                    <th>CCL Tree (TK.)</th>
                                    <th>CCL Crops (TK.)</th>
                                    <th>CCL Digging Pond (TK.)</th>
                                    <th>Tax Deduct (TK.)</th>
                                    <th>Difference of CCL (TK.)</th>
                                    <th>DC Rate</th>
                                    <th>PVAC Rate</th>
                                    <th>Additional</th>
                                    <th>CCL Value</th>
                                    <th>PVAC Rate Per Decimal</th>
                                    <th>Replacement Value</th>
                                    <th>Additional Grand For Land(AGL)</th>
                                    <th>Total AGL</th>
                                    <th>Remarks</th>
                                </tr>
                                <tr style="font-size: 10px !important;">
                                    <th>Col 0</th>
                                    <th>Col 1</th>
                                    <th>Col 2</th>
                                    <th>Col 3</th>
                                    <th>Col 4</th>
                                    <th>Col 5</th>
                                    <th>Col 6</th>
                                    <th>Col 7</th>
                                    <th>Col 8</th>
                                    <th>Col 9</th>
                                    <th>Col 10</th>
                                    <th>Col 11</th>
                                    <th>Col 12</th>
                                    <th>Col 13</th>
                                    <th>Col 14</th>
                                    <th>Col 15</th>
                                    <th>Col 16</th>
                                    <th>Col 17</th>
                                    <th>Col 18</th>
                                    <th>Col 19</th>
                                    <th>Col 20</th>
                                    <th>Col 21</th>
                                    <th>Col 22</th>
                                    <th>Col 23</th>
                                    <th>Col 24</th>
                                    <th>Col 25</th>
                                    <th>Col 26</th>
                                    <th>Col 27</th>
                                    <th>Col 28</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(estimate_calculation, index) in estimate_calculations">
                                    <tr
                                        v-if="estimate_calculation.lands.length > 0"
                                        v-for="(land, key_lands) in estimate_calculation.lands"
                                        :key="key_lands"
                                    >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ index + 1 }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            {{
                                                epIdWithPaymentStatus(
                                                    estimate_calculation.ep_id.ep_id,
                                                    estimate_calculation.ep_id.is_paid
                                                )
                                            }}
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <router-link
                                                :to="{ name: 'sesView', params: { ses_id: estimate_calculation.id } }"
                                                tag="a"
                                                target="_blank"
                                                >{{ estimate_calculation.name }}</router-link
                                            >
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'F'"
                                            ></div>
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'H'"
                                                >Husband Name:</div
                                            >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'S'"
                                                >Spouse Name:</div
                                            >
                                            {{ estimate_calculation.father_husband_name }}
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.mother_name }}</td
                                        >
                                        {{ flagPersonalDetails(0) }}
                                        <td
                                            ><span style="margin-left: 5px" v-if="land.ccl_land"
                                                >{{ land.ccl_land.ccl.book_no
                                                }}{{
                                                    land.ccl_land.ccl.book_sub_no != null
                                                        ? '/' + land.ccl_land.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            ></td
                                        >
                                        <td
                                            ><span v-if="land.mouza !== null">{{ land.mouza.mouza_desc }}</span></td
                                        >
                                        <td>{{
                                            land.ccl_land.ccl.la_case != null
                                                ? land.ccl_land.ccl.la_case.la_case_desc
                                                : ''
                                        }}</td>
                                        <td
                                            ><span style="margin-left: 5px">{{ land.plot_no }}</span></td
                                        >
                                        <td>{{ land.land_type.land_type_desc }}</td>
                                        <td>{{ land.self_affected }}</td>
                                        <td>{{ land.ccl_land.ccl.ccl_no }}</td>
                                        <td>{{ land.ccl_land.ccl.cheque_date }}</td>
                                        <td>{{ parseFloat(land.ccl_land.ccl_amount).toFixed(2) }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ land.land_tax }}</td>
                                        <td>{{ land.actual_difference }}</td>
                                        <td>{{ land.land_rate !== null ? land.land_rate.dc_rate : '0.00' }}</td>
                                        <td>{{ land.land_rate !== null ? land.land_rate.pvac_rate : '0.00' }}</td>
                                        <td>{{ land.additional_grand_ag }}</td>
                                        <td>{{ land.dc_amount }}</td>
                                        <td>{{ land.land_rate !== null ? land.land_rate.pvac_rate : '0.00' }}</td>
                                        <td>{{ land.pvac_amount }}</td>
                                        <td>{{ land.current_agl }}</td>
                                        <td
                                            v-if="key_lands === 0"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length
                                            "
                                            >{{ estimate_calculation.total_ep_agl }}</td
                                        >
                                        <td></td>
                                    </tr>
                                    <tr
                                        v-if="estimate_calculation.structures.length > 0"
                                        v-for="(structure, key_strus) in estimate_calculation.structures"
                                        :key="key_strus"
                                    >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ index + 1 }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.ep_id.ep_id }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <router-link
                                                :to="{ name: 'sesView', params: { ses_id: estimate_calculation.id } }"
                                                tag="a"
                                                target="_blank"
                                                >{{ estimate_calculation.name }}</router-link
                                            >
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'F'"
                                            ></div>
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'H'"
                                                >Husband Name:</div
                                            >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'S'"
                                                >Spouse Name:</div
                                            >
                                            {{ estimate_calculation.father_husband_name }}
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.mother_name }}</td
                                        >
                                        {{ flagPersonalDetails(0) }}
                                        <td
                                            ><span style="margin-left: 5px;"
                                                ><span v-if="structure.ccl_structure && structure.ccl_structure.ccl"
                                                    >{{ structure.ccl_structure.ccl.book_no
                                                    }}{{
                                                        structure.ccl_structure.ccl.book_sub_no != null
                                                            ? '/' + structure.ccl_structure.ccl.book_sub_no
                                                            : ''
                                                    }}</span
                                                >
                                            </span></td
                                        >
                                        <td
                                            ><span v-if="structure.land !== null">{{
                                                structure.land.mouza.mouza_desc
                                            }}</span></td
                                        >
                                        <td
                                            ><span style="margin-left: 5px;">{{
                                                structure.ccl_structure != null
                                                    ? structure.ccl_structure.ccl
                                                        ? structure.ccl_structure.ccl.la_case.la_case_desc
                                                        : ''
                                                    : ''
                                            }}</span></td
                                        >
                                        <td
                                            ><span v-if="structure.land !== null">{{
                                                structure.land.plot_no
                                            }}</span></td
                                        >
                                        <td>Structure</td>
                                        <td>0.00</td>
                                        <td>{{
                                            structure.ccl_structure != null
                                                ? structure.ccl_structure.ccl
                                                    ? structure.ccl_structure.ccl.ccl_no
                                                    : ''
                                                : ''
                                        }}</td>
                                        <td>{{
                                            structure.ccl_structure != null
                                                ? structure.ccl_structure.ccl
                                                    ? structure.ccl_structure.ccl.cheque_date
                                                    : ''
                                                : ''
                                        }}</td>
                                        <td>0.00</td>
                                        <td>{{
                                            structure.ccl_structure != null
                                                ? parseFloat(structure.ccl_structure.ccl_amount).toFixed(2)
                                                : ''
                                        }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ structure.structure_tax }}</td>
                                        <td>0.00</td>
                                        <!--                  <td>{{ structure.actual_difference }}</td>-->
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ structure.dc_amount }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        v-if="estimate_calculation.trees.length > 0"
                                        v-for="(tree, key_trees) in estimate_calculation.trees"
                                        :key="key_trees"
                                    >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ index + 1 }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.ep_id.ep_id }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <router-link
                                                :to="{ name: 'sesView', params: { ses_id: estimate_calculation.id } }"
                                                tag="a"
                                                target="_blank"
                                                >{{ estimate_calculation.name }}</router-link
                                            >
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'F'"
                                            ></div>
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'H'"
                                                >Husband Name:</div
                                            >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'S'"
                                                >Spouse Name:</div
                                            >
                                            {{ estimate_calculation.father_husband_name }}
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.mother_name }}</td
                                        >
                                        {{ flagPersonalDetails(0) }}
                                        <td
                                            ><span style="margin-left: 5px;"
                                                ><span v-if="tree.ccl_tree && tree.ccl_tree.ccl"
                                                    >{{ tree.ccl_tree.ccl.book_no
                                                    }}{{
                                                        tree.ccl_tree.ccl.book_sub_no !== null
                                                            ? '/' + tree.ccl_tree.ccl.book_sub_no
                                                            : ''
                                                    }}</span
                                                ></span
                                            ></td
                                        >
                                        <td
                                            ><span v-if="tree.land !== null">{{ tree.land.mouza.mouza_desc }}</span></td
                                        >
                                        <td
                                            ><span style="margin-left: 5px">{{
                                                tree.ccl_tree != null
                                                    ? tree.ccl_tree.ccl
                                                        ? tree.ccl_tree.ccl.la_case.la_case_desc
                                                        : ''
                                                    : ''
                                            }}</span></td
                                        >
                                        <td
                                            ><span v-if="tree.land !== null">{{ tree.land.plot_no }}</span></td
                                        >
                                        <td>Tree</td>
                                        <td>0.00</td>
                                        <td>{{
                                            tree.ccl_tree != null
                                                ? tree.ccl_tree.ccl
                                                    ? tree.ccl_tree.ccl.ccl_no
                                                    : ''
                                                : ''
                                        }}</td>
                                        <td>{{
                                            tree.ccl_tree != null
                                                ? tree.ccl_tree.ccl
                                                    ? tree.ccl_tree.ccl.cheque_date
                                                    : ''
                                                : ''
                                        }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{
                                            tree.ccl_tree != null ? parseFloat(tree.ccl_tree.ccl_amount).toFixed(2) : ''
                                        }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ tree.tree_tax }}</td>
                                        <td>0.00</td>
                                        <!--                  <td>{{ tree.actual_difference }}</td>-->
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ tree.dc_amount }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        v-if="estimate_calculation.crops.length > 0"
                                        v-for="(crop, key_crops) in estimate_calculation.crops"
                                        :key="key_crops"
                                    >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ index + 1 }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.ep_id.ep_id }}</td
                                        >
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <router-link
                                                :to="{ name: 'sesView', params: { ses_id: estimate_calculation.id } }"
                                                tag="a"
                                                target="_blank"
                                                >{{ estimate_calculation.name }}</router-link
                                            >
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                        >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'F'"
                                            ></div>
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'H'"
                                                >Husband Name:</div
                                            >
                                            <div
                                                style="font-weight:bold"
                                                v-if="estimate_calculation.father_hus_type === 'S'"
                                                >Spouse Name:</div
                                            >
                                            {{ estimate_calculation.father_husband_name }}
                                        </td>
                                        <td
                                            v-if="flagDetails === 1"
                                            :rowspan="
                                                estimate_calculation.lands.length +
                                                    estimate_calculation.structures.length +
                                                    estimate_calculation.trees.length +
                                                    estimate_calculation.crops.length
                                            "
                                            >{{ estimate_calculation.mother_name }}</td
                                        >

                                        <td
                                            ><span v-if="crop.ccl_crop && crop.ccl_crop.ccl"
                                                >{{ crop.ccl_crop.ccl.book_no
                                                }}{{
                                                    crop.ccl_crop.ccl.book_sub_no != null
                                                        ? '/' + crop.ccl_crop.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            ></td
                                        >
                                        <td
                                            ><span v-if="crop.land !== null">{{ crop.land.mouza.mouza_desc }}</span></td
                                        >
                                        <td>{{
                                            crop.ccl_crop.ccl.la_case != null
                                                ? crop.ccl_crop.ccl.la_case.la_case_desc
                                                : ''
                                        }}</td>
                                        <td
                                            ><span v-if="crop.land !== null">{{ crop.land.plot_no }}</span></td
                                        >
                                        <td>Crops</td>
                                        <td>0.00</td>
                                        <td
                                            ><span>{{ crop.ccl_crop.ccl.ccl_no }}</span></td
                                        >
                                        <td>{{ crop.ccl_crop.ccl.cheque_date }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ parseFloat(crop.ccl_crop.ccl_amount).toFixed(2) }}</td>
                                        <td>0.00</td>
                                        <td>{{ crop.crop_tax }}</td>
                                        <td>0.00</td>
                                        <!--                  <td>{{ crop.actual_difference }}</td>-->
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>{{ crop.dc_amount }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {{ flagPersonalDetails(1) }}
                                </template>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import XLSX, { NumberFormat, WSSpec } from 'xlsx'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
    page: {
        title: 'List SES',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'Search SES',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'SES',
                    active: true,
                },
            ],
            estimate_calculations: [],
            //flagDetails : 1,
            total_ep_agl: 0,
            current_agl: 0,
        }
    },

    mounted() {
        this.flagDetails = 1
        this.estimateCalculation()
    },
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        estimateCalculation() {
            let ses_eps = this.$route.query.ses_eps
            let ses_power_group_ids = this.$route.query.ses_power_group_ids
            http.post('api/estimate/calculation/create', { ses_eps: ses_eps, ses_power_group_ids: ses_power_group_ids })
                .then((response) => {
                    this.estimate_calculations = response.data.estimate_calculations
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        flagPersonalDetails(FlagVal) {
            if (FlagVal === 1) {
                this.flagDetails = 1
            } else {
                this.flagDetails = 0
            }
            //alert(this.flagDetails)
        },
        onexport(evt) {
            var tbl = document.getElementById('titledExcel')
            var wb = XLSX.utils.table_to_book(tbl, {
                raw: true,
                NumberFormat: 'string',
                cellDates: false,
            })
            XLSX.writeFile(wb, 'estimate-calculation.xlsx')
        },
    },
}
</script>
<style>
.scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
